import type {OperationVariables, QueryOptions, MutationOptions} from "@apollo/client"
import {isMatching, P} from "ts-pattern"
import client from "./client"
import type {PBApolloError} from "./helpers/hookShared"

const gqlIsErr = isMatching({error: P.nonNullable})

async function gqlQuery<T = unknown, TVariables extends OperationVariables = OperationVariables>(
  options: QueryOptions<TVariables, T>
): Promise<
  | {
      data: T
    }
  | {
      error: PBApolloError
      errorMsg: string
    }
> {
  try {
    const res = await client.query(options)
    return res
  } catch (err) {
    const e = err as PBApolloError
    return Promise.resolve({error: e, errorMsg: e.networkError?.formattedMessage ?? e.message})
  }
}
async function gqlMutation<T = unknown, TVariables extends OperationVariables = OperationVariables>(
  options: MutationOptions<TVariables, T>
): Promise<
  | {
      data: T
    }
  | {
      error: PBApolloError
      errorMsg: string
    }
> {
  try {
    const res = (await client.mutate(options as any)) as any
    return res
  } catch (err) {
    const e = err as PBApolloError
    return Promise.resolve({error: e, errorMsg: e.networkError?.formattedMessage ?? e.message})
  }
}

export const gqlService = {
  isErr: gqlIsErr,
  query: gqlQuery,
  mutation: gqlMutation
}
